module.exports = __webpack_public_path__ + "static/img/imagem-tipos-licenca.ddbdf3ba.png";